module.exports = __webpack_public_path__ + "media/src/images/partners/jgu-0d2864c2aeca72befc7cca5737b5d561.jpg";